import React from 'react';
import styles from './ChargingPageCustom_Kratos.module.css'
import DashboardMain_Kratos from '../DashboardMain_Kratos/DashboardMain_Kratos';
import * as $ from 'jquery';
import { useCallback, useContext, useEffect, useState } from "react";
import { INIT_FILTER_STATE } from '../../../constants/driveglobalfilterinitalstates_kratos';
import { API_URL_MAIN } from '../../../constants/driveglobalfilterinitalstates_kratos';
import useHttp from '../../../hook/use-http'
import AppContext from '../../../store/AppContext';
import ChargingFirstPageKpis_Kratos from './ChargingFirstPage_Kratos/ChargingFirstPageKpis_Kratos';
import HighlightsKpis_Kratos from './ChargingFirstPage_Kratos/HighlightsKpis_Kratos';
import ChargingInterruptionDuration_Kratos from './ChargingFirstPage_Kratos/ChargingInterruptionDuration_Kratos';

import { useSelector } from 'react-redux';
import { selectLoggedInUser } from "../../../redux/userSlice"
import GunConnectVehicles_Kratos from './ChargingFirstPage_Kratos/GunConnectVehicles_Kratos';
import GunConnectCycles_Kratos from './ChargingFirstPage_Kratos/GunConnectCycles_Kratos';
import SocAtChargeStartVehicles_Kratos from './ChargingFirstPage_Kratos/SocAtChargeStartVehicles_Kratos';
import SocAtChargeStartCycles_Kratos from './ChargingFirstPage_Kratos/SocAtChargeStartCycles_Kratos';
import RateOfChargeCycles_Kratos from './ChargingFirstPage_Kratos/RateOfChargeCycles_Kratos';
import RateOfChargeVehicles_Kratos from './ChargingFirstPage_Kratos/RateOfChargeVehicles_Kratos';
import AverageChargeCurrentCycles_Kratos from './ChargingFirstPage_Kratos/AverageChargeCurrentCycles_Kratos';
import AverageChargeCurrentVehicles_Kratos from './ChargingFirstPage_Kratos/AverageChargeCurrentVehicles_Kratos';
import Charged_Per_SOC_Cycles_Kratos from './ChargingFirstPage_Kratos/Charged_Per_SOC_Cycles_Kratos';
import Charged_Per_SOC_Vehicles_Kratos from './ChargingFirstPage_Kratos/Charged_Per_SOC_Vehicles_Kratos';
import Charged_Per_KWH_Cycles_Kratos from './ChargingFirstPage_Kratos/Charged_Per_KWH_Cycles_Kratos';
import Charged_Per_KWH_Vehicles_Kratos from './ChargingFirstPage_Kratos/Charged_Per_KWH_Vehicles_Kratos';
import MaxCellTemp_cycles_Kratos from './ChargingFirstPage_Kratos/MaxCellTemp_cycles_Kratos';
import MaxCellTemp_vehicles_Kratos from './ChargingFirstPage_Kratos/MaxCellTemp_vehicles_Kratos';
import MaxCellVoltage_cycles_Kratos from './ChargingFirstPage_Kratos/MaxCellVoltage_cycles_Kratos';
import MaxCellVoltage_vehicles_Kratos from './ChargingFirstPage_Kratos/MaxCellVoltage_vehicles_Kratos';
import Charging_Filters_Kratos from './Charging_Filters_Kratos';
import CandlestickChart_Kratos from './ChargingFirstPage_Kratos/CandlestickChart_Kratos';
import { decodeToken } from 'react-jwt';

export default function ChargingPage_Kratos() {
  const tokenNew = JSON.parse(sessionStorage.user);
  let decodedToken = decodeToken(tokenNew.token);
  const city_name = decodedToken.city_name;
  const city_name_arr = city_name.split(",");
  const depo_name = decodedToken.depo_name;
  const depo_name_arr = depo_name.split(",");
  let sampleObj = (city_name != "") ? { ...INIT_FILTER_STATE, CITY: city_name_arr, DEPO: depo_name_arr } : INIT_FILTER_STATE

  const [gloablfilter, setGloablfilter] = useState(sampleObj)
  const { isLoading, error, sendReq: fetchData } = useHttp();
  const app_ctx = useContext(AppContext);

  const log_data = (data) => {
  }

  useEffect(() => {
    window.$("#button-1_Kratos").checked = false
    fetchData({
      url: API_URL_MAIN + "auth/logging", body: {
        page_name: "Charginganalysis_Kratos"
      }
    }, log_data)
  }, []);

  const [toSeeChartType, setToSeeChartType] = useState('d-block');
  const [toSeeToggle, setToSeeToggle] = useState('d-block');
  useEffect(() => {
    if (gloablfilter.VIN_NUM.length === 1) {
      setChartType_option("candle")
      setToSeeChartType('d-block')
      setToSeeToggle('d-none');
      setTypeSOC("Fast");
      setTypeMaxTempBattery("Fast")
      setPerCycle("Fast")
      setType('Fast')
      setTypeFCD("Fast")
      setMaxCellTemp("Fast")
      setMaxCellVoltage("Fast")
      SetChartName("Charging Pattern")
    } else {
      setToSeeChartType('d-none')
      setToSeeToggle('d-block')
    }
  }, [gloablfilter]);

  const [fromTableToFilter_vin, setFromTableToFilter_vin] = useState(0);
  const filterSubmited = useCallback((data) => {
    if (data.VIN_NUM.length === 1) {
      setFromTableToFilter_vin(data.VIN_NUM[0])
    }
    setGloablfilter(data);
  }, []);

  const singleVinSelected = (vin) => {
    let vin_num = vin.split(",");
    setFromTableToFilter_vin(vin_num[0])
    setGloablfilter((prevdata) => { return { ...prevdata, VIN_NUM: vin_num, pageSelected: 2 } });
  }

  const onreset = (data) => {
    setGloablfilter(data);
  }

  // code for ROC 
  const [chartSelected, setChartSelected] = useState('bar')
  const [type, setType] = useState('Slow')
  const [ROC_SF, setROC_SF] = useState('Slow')
  const changeTB = (selectedOption) => {
    setChartSelected(selectedOption)
  }
  const handleChangeROC = (e) => {
    if (e.target.checked === false) {
      setType('Slow')
      setROC_SF('Slow')
    } else {
      setType('Fast')
      setROC_SF('Fast')
    }
  }
  // code for ROC

  // code for BMS
  const [perCycle_Option, setPerCycle_Option] = useState('soc')
  const [soc_kwh_tiltle, setSoc_kwh_tiltle] = useState('SOC Charged per Cycle')
  const changePerCycle = (selectedOption) => {
    setSoc_kwh_tiltle(selectedOption.target.selectedOptions[0].innerHTML + " Charged per Cycle")
    setPerCycle_Option(selectedOption.target.value)
  }
  // code for BMS 

  // code for max cell temp
  const [chartnameSOC1, SetChartNameSOC1] = useState("Max Cell Temp");
  const [maxCellTemp_Option, setMaxCellTemp_Option] = useState('Max_Cell_Temp')
  const changeMaxCellTemp = (event) => {
    SetChartNameSOC1(event.target.selectedOptions[0].innerHTML + " - Max Cell Temp")
    // SetChartNameSOC1("Pack " + event.target.selectedOptions[0].innerHTML + " - Max Cell Temp")
    setMaxCellTemp_Option(event.target.value)
  }
  const [maxCellTemp, setMaxCellTemp] = useState('Slow')
  const [chartNameMaxCellTemp, setChartNameMaxCellTemp] = useState("AAAAAAAAA");
  const handleMaxCellTemp = (e) => {
    if (e.target.checked === false) {
      setMaxCellTemp("Slow")
      setChartNameMaxCellTemp("SOC at which charging starts")
    } else {
      setMaxCellTemp("Fast")
      setChartNameMaxCellTemp("SOC at which charging starts")
    }
  }
  // code for max cell temp

  // code for max cell voltage
  const [chartnameSOC2, SetChartNameSOC2] = useState("Min Cell Volt");
  const [maxCellVoltage_Option, setMaxCellVoltage_Option] = useState('A_Min_Cell_Volt')
  const [maxCellVoltage_OptionMM, setMaxCellVoltage_OptionMM] = useState('Min')
  const changeMaxCellVoltageMM = (selectedOption) => {
    SetChartNameSOC2(selectedOption + " Cell Volt")
    setMaxCellVoltage_OptionMM(selectedOption)
    setMaxCellVoltage_Option(maxCellVoltageO + selectedOption + '_Cell_Volt')
  }
  const [maxCellVoltageO, setMaxCellVoltageO] = useState('A_')
  const changeMaxCellVoltage = (selectedOption) => {
    SetChartNameSOC2("Pack " + selectedOption.replace(/_/g, '') + " - " + maxCellVoltage_OptionMM + " Cell Volt")
    setMaxCellVoltageO(selectedOption)
    setMaxCellVoltage_Option(selectedOption + maxCellVoltage_OptionMM + '_Cell_Volt')
  }
  const [maxCellVoltage, setMaxCellVoltage] = useState('Slow')
  const [chartNameMaxCellVoltage, setChartNameMaxCellVoltage] = useState("AAAAAAAAA");
  const handleMaxCellVoltage = (e) => {
    if (e.target.checked === false) {
      setMaxCellVoltage("Slow")
      setChartNameMaxCellVoltage("SOC at which charging starts")
    } else {
      setMaxCellVoltage("Fast")
      setChartNameMaxCellVoltage("SOC at which charging starts")
    }
  }
  // code for max cell voltage

  // code for FCD
  const [typeFCD, setTypeFCD] = useState('Slow')
  const [check, SetCheck] = useState("gunDurationInMin");
  const [chartname, SetChartName] = useState("Gun Connect Duration");
  const [API_FCD, SetAPI_FCD] = useState("gun_connect_duration_vehicles");
  const handleFCD = (e) => {
    if (e.target.checked === false) {
      setTypeFCD("Slow")
      SetCheck("gunDurationInMin")
      SetChartName("Gun Connect Duration");
      SetAPI_FCD("gun_connect_duration_vehicles");
    } else {
      setTypeFCD("Fast")
      SetCheck("FC10_80TimeInMin")
      SetChartName("Gun Connect Duration")
      SetAPI_FCD("gun_connect_duration_cycles")
    }
  }
  // code for FCD

  // code for max temp
  const [typeMaxTemp, setTypeMaxTemp] = useState('Slow')
  const [chartnameMT, SetChartNameMT] = useState("Max coolant temp(oC) - Slow chrg");
  const handleMaxTemp = (e) => {
    if (e.target.checked === false) {
      setTypeMaxTemp("Slow")
      SetChartNameMT("Max coolant temp(oC) - Slow chrg")
    } else {
      setTypeMaxTemp("Fast")
      SetChartNameMT("Max coolant temp(oC) - Fast chrg")
    }
  }
  // code for max temp

  // code for SOC
  const [typeSOC, setTypeSOC] = useState('Slow')
  const [chartnameSOC, SetChartNameSOC] = useState("Avg Charging Current");
  const handleSOC = (e) => {
    if (e.target.checked === false) {
      setTypeSOC("Slow")
      SetChartNameSOC("Avg Charging Current")
    } else {
      setTypeSOC("Fast")
      SetChartNameSOC("Avg Charging Current")
    }
  }
  // code for SOC

  // code for max Battery temp
  const [typeMaxTempBattery, setTypeMaxTempBattery] = useState('Slow')
  const [chartnameMaxTempBattery, SetChartNameMaxTempBattery] = useState("SOC at which charging starts");
  const handleMaxTempBattery = (e) => {
    if (e.target.checked === false) {
      setTypeMaxTempBattery("Slow")
      SetChartNameMaxTempBattery("SOC at which charging starts")
    } else {
      setTypeMaxTempBattery("Fast")
      SetChartNameMaxTempBattery("SOC at which charging starts")
    }
  }
  // code for max Battery temp

  // code for soc charged per cycles
  const [perCycle, setPerCycle] = useState('Slow')
  const [chartNamePerCycle, setChartNamePerCycle] = useState("AAAAAAAAA");
  const handleChangeSocPerCycle = (e) => {
    if (e.target.checked === false) {
      setPerCycle("Slow")
      setChartNamePerCycle("SOC at which charging starts")
    } else {
      setPerCycle("Fast")
      setChartNamePerCycle("SOC at which charging starts")
    }
  }
  // code for soc charged per cycles
  const [chartType_option, setChartType_option] = useState("bar")
  const changeChartType = (selectedOption) => {
    setChartType_option(selectedOption)
    if (selectedOption === "bar") {
      SetChartName("Charging Session Duration")
    } else {
      SetChartName("Charging Pattern")
    }
  }

  const loggedInUser = useSelector(selectLoggedInUser);
  return (
    <>
      <DashboardMain_Kratos>
        <Charging_Filters_Kratos onsubmit={filterSubmited} gloablfilter={gloablfilter} onreset={onreset} fromTableToFilter_vin={fromTableToFilter_vin} />
        <div className={`container-fluid ${styles.kratosdrpg1}`} >
          <ChargingFirstPageKpis_Kratos gloablfilter={gloablfilter} />
          <section className="highlights">
            <div className="row">
              <HighlightsKpis_Kratos gloablfilter={gloablfilter} />
            </div>
          </section>

          <section className="highlights">
            <div className="row mb-3 equal-cols">
              {/* chart moved side to table */}
              <div className="col-lg-3 col-md-6 col-sm-12 pr-0">
                <div className={`${styles.chargingChartboxNew_Kratos}`}>
                  <div className={`v-title ${styles.chargingTitleChart_Kratos}`}>
                    <div className="row">
                      <div className="col-lg-9 col-md-9 col-sm-9 col-9">
                        <div className="p-2"><b>{chartnameSOC}</b></div>
                      </div>
                      <div className={`col-lg-3 col-md-3 col-sm-3 col-3 ${toSeeToggle}`}>
                        <div className={`${styles.toggleBtn_Kratos} pt-0`}>
                          <div className={`${styles["toggle-button-cover"]}`}>
                            <div className={`${styles["button-cover"]}`}>
                              <div className={`${styles.buttonbtn.r}`} id="button-1_Kratos">
                                <input type="checkbox" className={`${styles.checkbox}`} onChange={handleSOC} />
                                <div className={`${styles.knobs}`} />
                                <div className={`${styles.layer}`} />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className={`${styles.chargingChartHGT_Kratos}`}>
                    {
                      typeSOC === "Slow" ?
                        <AverageChargeCurrentVehicles_Kratos gloablfilter={gloablfilter} apiend={"average_vehicles"} type={typeSOC} chartnameFCD="" />
                        :
                        <AverageChargeCurrentCycles_Kratos gloablfilter={gloablfilter} apiend="average_cycles" type={typeSOC} />
                    }
                  </div>
                </div>
              </div>
              {/* chart moved side to table */}

              <ChargingInterruptionDuration_Kratos gloablfilter={gloablfilter} singleVinSelected={singleVinSelected} />
            </div>
          </section>

          {/* } */}
          <section className="graphs">
            <div className="row mt-2 mb-3 equal-cols">
              {/* chart moved side to table */}

              <div className="col-lg-4 col-md-4 col-sm-12 pr-0">
                <div className={`${styles.chargingChartbox_Kratos} ${styles.wd_4_charts_Kratos}`}>
                  <div className={`v-title ${styles.chargingTitleChart_Kratos}`}>
                    <div className="row">
                      <div className="col-lg-9 col-md-9 col-sm-9 col-9">
                        <div className="p-2"><b>{chartnameMaxTempBattery}</b></div>
                      </div>
                      <div className={`col-lg-3 col-md-3 col-sm-3 col-3 ${toSeeToggle}`}>
                        <div className={`${styles.toggleBtn_Kratos} pt-0`}>
                          <div className={`${styles["toggle-button-cover"]}`}>
                            <div className={`${styles["button-cover"]}`}>
                              <div className={`${styles.buttonbtn.r}`} id="button-1_Kratos">
                                <input type="checkbox" className={`${styles.checkbox}`} onChange={handleMaxTempBattery} />
                                <div className={`${styles.knobs}`} />
                                <div className={`${styles.layer}`} />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className={`${styles.chargingChartHGT_Kratos}`}>
                    {
                      typeMaxTempBattery === "Slow" ?
                        <SocAtChargeStartVehicles_Kratos gloablfilter={gloablfilter} apiend={"soc_at_charge_start_vehicles"} type={typeMaxTempBattery} chartnameFCD="" />
                        :
                        <SocAtChargeStartCycles_Kratos gloablfilter={gloablfilter} apiend="soc_at_charge_start_cycles" type={typeMaxTempBattery} />
                    }
                  </div>
                </div>
              </div>

              <div className="col-lg-4 col-md-4 col-sm-12 pr-0">
                <div className={`${styles.chargingChartbox_Kratos} ${styles.wd_4_charts_Kratos}`}>
                  <div className={`v-title ${styles.chargingTitleChart_Kratos}`}>
                    <div className="row ">
                      <div className="col-lg-6 col-sm-6">
                        <div className="p-2 text-start"><b>{soc_kwh_tiltle}</b></div>
                      </div>
                      <div className="col-lg-3 col-md-3 col-sm-3 col-3">
                        <select className="form-select form-select-sm mt-1" aria-label=".form-select-sm example" onChange={(event) => changePerCycle(event)}
                          value={perCycle_Option}>
                          <option value="kwh">kWh</option>
                          <option value="soc">Soc</option>
                        </select>
                      </div>
                      <div className={`col-lg-3 col-sm-3 text-end ${toSeeToggle}`}>
                        <div className={`${styles.toggleBtn_Kratos}`}>
                          <div className={`${styles["toggle-button-cover"]}`}>
                            <div className={`${styles["button-cover"]}`}>
                              {/* added for design */}
                              <div className={`${styles.buttonbtn.r}`} id="button-1_Kratos">
                                <input type="checkbox" className={`${styles.checkbox}`} onChange={handleChangeSocPerCycle} />
                                <div className={`${styles.knobs}`} />
                                <div className={`${styles.layer}`} />
                              </div>
                              {/* added for design */}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className={`${styles.chargingChartHGT_Kratos}`}>
                    {
                      (perCycle_Option === "soc" && perCycle === "Slow") &&
                      <Charged_Per_SOC_Vehicles_Kratos gloablfilter={gloablfilter} apiend={"soc_charged_per_vehicles"} type={perCycle} chartnameFCD={soc_kwh_tiltle} />
                    }
                    {
                      (perCycle_Option === "soc" && perCycle !== "Slow") &&
                      <Charged_Per_SOC_Cycles_Kratos gloablfilter={gloablfilter} apiend="soc_charged_per_cycles" type={perCycle} chartnameFCD={soc_kwh_tiltle} />
                    }
                    {
                      (perCycle_Option === "kwh" && perCycle === "Slow") &&
                      <Charged_Per_KWH_Vehicles_Kratos gloablfilter={gloablfilter} apiend={"kwh_charged_per_vehicles"} type={perCycle} chartnameFCD={soc_kwh_tiltle} />
                    }
                    {
                      (perCycle_Option === "kwh" && perCycle !== "Slow") &&
                      <Charged_Per_KWH_Cycles_Kratos gloablfilter={gloablfilter} apiend="kwh_charged_per_cycles" type={perCycle} chartnameFCD={soc_kwh_tiltle} />
                    }

                  </div>
                </div>
              </div>

              <div className="col-lg-4 col-md-4 col-sm-12">
                <div className={`${styles.chargingChartbox_Kratos} ${styles.wd_4_charts_Kratos}`}>
                  <div className={`v-title ${styles.chargingTitleChart_Kratos}`}>
                    <div className="row">
                      <div className="col-lg-5 col-md-6 col-sm-5 col-5">
                        <div className="p-2"><b>Rate of charge</b></div>
                      </div>
                      <div className="col-lg-7 col-md-6 col-sm-7 col-7">
                        <div className="row">
                          <div className="col-lg-6 col-md-6 col-sm-6 col-6">
                            <div className="dropdownSelectBtnCharging_Kratos">
                            </div>
                          </div>
                          <div className={`col-lg-6 col-md-6 col-sm-6 col-6 ${toSeeToggle}`}>
                            <div className={`${styles.toggleBtn_Kratos} pt-0`}>
                              <div className={`${styles["toggle-button-cover"]}`}>
                                <div className={`${styles["button-cover"]}`}>
                                  <div className={`${styles.buttonbtn.r}`} id="button-1_Kratos">
                                    <input type="checkbox" className={`${styles.checkbox}`} onChange={handleChangeROC} />
                                    <div className={`${styles.knobs}`} />
                                    <div className={`${styles.layer}`} />
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className={`${styles.chargingChartHGT_Kratos}`}>
                    {
                      type === "Slow" ?
                        <RateOfChargeVehicles_Kratos gloablfilter={gloablfilter} apiend="roc_vehicles" type={type} chartnameFCD="" />
                        :
                        <RateOfChargeCycles_Kratos gloablfilter={gloablfilter} apiend="roc_cycles" type={type} />
                    }
                  </div>
                </div>
              </div>

            </div>
            <div className="row equal-cols">
              <div className="col-lg-4 col-md-6 col-sm-12 pr-0 mb-3">
                <div className={`${styles.chargingChartbox_Kratos} ${styles.wd_4_charts_Kratos}`}>
                  <div className={`v-title ${styles.chargingTitleChart_Kratos}`}>
                    <div className="row">
                      <div className={toSeeChartType === "d-block" ? "col-lg-6 col-md-6 col-sm-6 col-6" : "col-lg-9 col-md-9 col-sm-9 col-9"}>
                        <div className="p-2 text-start"><b>{chartname}</b></div>
                      </div>
                      <div className={`col-lg-3 col-md-3 col-sm-3 col-3 ${toSeeChartType}`}>
                        <select className="form-select form-select-sm mt-1" aria-label=".form-select-sm example" onChange={(event) => changeChartType(event.target.value)}
                          value={chartType_option}>
                          <option value="bar">Charging Session Duration</option>
                          <option value="candle">Charging Pattern</option>
                        </select>
                      </div>
                      <div className={`col-lg-3 col-md-3 col-sm-3 col-3 ${toSeeToggle}`}>
                        <div className={`${styles.toggleBtn_Kratos} pt-0`}>
                          <div className={`${styles["toggle-button-cover"]}`}>
                            <div className={`${styles["button-cover"]}`}>
                              <div className={`${styles.buttonbtn.r}`} id="button-1_Kratos">
                                <input type="checkbox" className={`${styles.checkbox}`} onChange={handleFCD} />
                                <div className={`${styles.knobs}`} />
                                <div className={`${styles.layer}`} />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className={`${styles.chargingChartHGT_Kratos}`}>
                    {
                      typeFCD === "Slow" ?
                        <GunConnectVehicles_Kratos gloablfilter={gloablfilter} apiend="gun_connect_duration_vehicles" type={typeFCD} chartnameFCD={chartname} />
                        :
                        (chartType_option === "bar") ?
                          <GunConnectCycles_Kratos gloablfilter={gloablfilter} apiend="gun_connect_duration_cycles" type={typeFCD} chartType_option={chartType_option} chartnameFCD={chartname} />
                          :
                          <CandlestickChart_Kratos gloablfilter={gloablfilter} apiend="gun_connect_duration_cycles_candle" type={typeFCD} chartType_option={chartType_option} chartnameFCD={chartname} />
                    }
                  </div>
                </div>
              </div>

              <div className="col-lg-4 col-md-6 col-sm-12 pr-0 mb-3">
                <div className={`${styles.chargingChartbox_Kratos} ${styles.wd_4_charts_Kratos}`}>
                  <div className={`v-title ${styles.chargingTitleChart_Kratos}`}>
                    <div className="row">
                      <div className="col-lg-6 col-md-6 col-sm-6 col-6">
                        <div className="p-2"><b>{chartnameSOC1}</b></div>
                      </div>
                      {/* <div className="col-lg-4 col-md-4 col-sm-4 col-4">
                        <select className="form-select form-select-sm mt-1" aria-label=".form-select-sm example" onChange={(event) => changeMaxCellTemp(event)} value={maxCellTemp_Option} >
                          <option value="Max_Cell_Temp">Pack A</option>
                          <option value="B_Max_Cell_Temp">Pack B</option>
                          <option value="C_Max_Cell_Temp">Pack C</option>
                          <option value="D_Max_Cell_Temp">Pack D</option>
                        </select>
                      </div> */}
                      <div className={`col-lg-2 col-md-2 col-sm-2 col-2 ${toSeeToggle}`} style={{ paddingLeft: "0px" }}>
                        <div className={`${styles.toggleBtn_Kratos} pt-0`}>
                          <div className={`${styles["toggle-button-cover"]}`}>
                            <div className={`${styles["button-cover"]}`}>
                              <div className={`${styles.buttonbtn.r}`} id="button-1_Kratos">
                                <input type="checkbox" className={`${styles.checkbox}`} onChange={handleMaxCellTemp} />
                                <div className={`${styles.knobs}`} />
                                <div className={`${styles.layer}`} />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className={`${styles.chargingChartHGT_Kratos}`}>
                    {
                      maxCellTemp === "Slow" ?
                        <MaxCellTemp_vehicles_Kratos gloablfilter={gloablfilter} apiend={"max_cell_temp_vehicles"} type={maxCellTemp} chartnameFCD={chartnameSOC1} maxCellTemp_Option={maxCellTemp_Option} />
                        :
                        <MaxCellTemp_cycles_Kratos gloablfilter={gloablfilter} apiend="max_cell_temp_cycles" type={maxCellTemp} maxCellTemp_Option={maxCellTemp_Option} chartnameFCD={chartnameSOC1} />
                    }
                  </div>
                </div>
              </div>

              <div className="col-lg-4 col-md-6 col-sm-12 mb-3">
                <div className={`${styles.chargingChartbox_Kratos} ${styles.wd_4_charts_Kratos}`}>
                  <div className={`v-title ${styles.chargingTitleChart_Kratos}`}>
                    <div className="row">
                      <div className="col-lg-4 col-md-4 col-sm-4 col-4">
                        <div className="pt-2 pb-2" style={{ fontSize: "11px", paddingLeft: "3px" }}><b>{chartnameSOC2}</b></div>
                      </div>
                      <div className="col-lg-3 col-md-3 col-sm-3 col-3 pr-1 pl-1 pt-1">
                        <select className="form-select form-select-sm" aria-label=".form-select-sm example" onChange={(event) => changeMaxCellVoltageMM(event.target.value)} value={maxCellVoltage_OptionMM}>
                          <option value="Min">Min</option>
                          <option value="Max">Max</option>
                        </select>
                      </div>
                      {/* <div className="col-lg-3 col-md-3 col-sm-3 col-3 pr-1 pl-1 pt-1">
                        <select className="form-select form-select-sm" aria-label=".form-select-sm example" onChange={(event) => changeMaxCellVoltage(event.target.value)} value={maxCellVoltageO}>
                          <option value="A_">Pack A</option>
                          <option value="B_">Pack B</option>
                          <option value="C_">Pack C</option>
                          <option value="D_">Pack D</option>
                        </select>
                      </div> */}
                      <div className={`col-lg-2 col-md-2 col-sm-2 col-2 pl-0 ${toSeeToggle}`} style={{ paddingLeft: "0px" }}>
                        <div className={`${styles.toggleBtn_Kratos} pt-0`}>
                          <div className={`${styles["toggle-button-cover"]}`}>
                            <div className={`${styles["button-cover"]}`}>
                              <div className={`${styles.buttonbtn.r}`} id="button-1_Kratos">
                                <input type="checkbox" className={`${styles.checkbox}`} onChange={handleMaxCellVoltage} />
                                <div className={`${styles.knobs}`} />
                                <div className={`${styles.layer}`} />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className={`${styles.chargingChartHGT_Kratos}`}>
                    {
                      maxCellVoltage === "Slow" ?
                        <MaxCellVoltage_vehicles_Kratos gloablfilter={gloablfilter} apiend={"max_cell_voltage_vehicles"} type={maxCellVoltage} chartnameFCD={chartnameSOC2} maxCellVoltage_Option={maxCellVoltage_Option} maxCellVoltage_OptionMM={maxCellVoltage_OptionMM} />
                        :
                        <MaxCellVoltage_cycles_Kratos gloablfilter={gloablfilter} apiend="max_cell_voltage_cycles" type={maxCellVoltage} maxCellVoltage_Option={maxCellVoltage_Option} chartnameFCD={chartnameSOC2} />
                    }
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </DashboardMain_Kratos>
    </>
  )
}